import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    dataContainer: {
        display: "flex",
        gap: theme.spacing(14),
        paddingBottom: theme.spacing(4),
    },
    itemContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    title: {
        color: theme.palette.primary.dark,
    },
    text: {
        color: theme.palette.text.primary,
    },
}));
